module.exports = {"130283100":"迁安镇","130283101":"夏官营镇","130283102":"杨各庄镇","130283103":"建昌营镇","130283104":"赵店子镇","130283105":"野鸡坨镇","130283106":"大崔庄镇","130283107":"杨店子镇","130283108":"蔡园镇","130283109":"马兰庄镇","130283110":"沙河驿镇","130283111":"木厂口镇","130283200":"扣庄乡","130283201":"彭店子乡","130283202":"上射雁庄乡","130283203":"闫家店乡","130283204":"五重安乡","130283205":"大五里乡","130283206":"太平庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130283.json
// module id = 91
// module chunks = 0